import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
// Services and Actions
import { setLoading } from '../../modules/PageLoader/actions'
// Components
import IdentifiersList from '../../modules/IdentifiersList'
import { Heading, Paragraph, Content, SearchBox, LoadingContainer, LoadingText } from './styles'
import SearchForm from 'app/modules/SearchForm'
import ManagementModal from 'app/modules/ManageInfoModal'
// Assets
import IconLoading from 'app/elements/Icon/ic-loading'

import { gqlQuery } from '../../../alelo-logic/services/common/apolloClient'
import { gqlIdentificadoresPaginado } from '../../../alelo-logic/services/queries/vehicles'

import {
  helmetTitle,
  identifiersTitle,
  identifiersDescription,
  noIdentifierTitle,
  noIdentifierDescription
} from './data.json'

class DashboardIdentifiersPartners extends Component {
  constructor(props) {
    super(props)
    this.state = {
      itemsSelected: [],
      searchText: '',
      identifiersList: [],
      listGrowNumber: 20,
      isLoadingMoreItems: false,
      modalOpen: false,
      vehicle: {},
      paginacao: {}
    }
  }

  async componentDidMount() {
    this.props.setLoading(false)
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { vehicles } = this.props
    if (prevProps.vehicles !== vehicles && vehicles.length > 0) {
      this._prepareVehiclesList()
    }
  }

  _prepareVehiclesList = () => {
    const { vehicles, setLoading } = this.props
    const { listGrowNumber } = this.state
    const newVehicles = this.handleSortIdentifier(vehicles)
    if (newVehicles.length > listGrowNumber) {
      this.setState({ identifiersList: newVehicles.slice(0, listGrowNumber) })
    } else {
      this.setState({ identifiersList: newVehicles })
    }
    setLoading(false)
  }

  handleSearchChange = ({ target }) => {
    this.setState({ searchText: target.value })
  }

  // Checkbox
  handleSelectItem = item => () => {
    const { itemsSelected } = this.state
    let newArray
    const hasItem =
      itemsSelected.findIndex(({ idIdentificador }) => item.idIdentificador === idIdentificador) !==
      -1
    if (hasItem) {
      newArray = itemsSelected.filter(
        ({ idIdentificador }) => item.idIdentificador !== idIdentificador
      )
      return this.setState({ itemsSelected: newArray })
    }
    newArray = [...itemsSelected, item]
    this.setState({ itemsSelected: newArray })
  }

  handleSelectAll = () => {
    const { itemsSelected, identifiersList } = this.state
    if (itemsSelected.length === identifiersList.length) {
      return this.setState({ itemsSelected: [] })
    }
    this.setState({ itemsSelected: identifiersList })
  }

  // Infinity List
  loadMoreItems = async () => {
    const { paginacao: page } = this.state

    if (page.proxima && this.state.isLoadingMoreItems === false) {
      this.setState({ isLoadingMoreItems: true })
      const { identificadores, paginacao } = await this.props.fetchVehicles(
        this.props.match.params.id,
        '',
        '',
        null,
        page.proxima,
        page.quantidade
      )
      setTimeout(
        () =>
          this.setState(
            {
              identifiersList: [...this.state.identifiersList, ...identificadores],
              paginacao
            },
            () => this.setState({ isLoadingMoreItems: false })
          ),
        400
      )
    }
  }

  // Modal
  handleModalCreateInfo = vehicle => {
    this.setState({ modalOpen: true, vehicle })
  }

  handleCloseModal = async () => {
    this.setState({ modalOpen: false, vehicle: {} })
    const { match, history, fetchVehicles } = this.props
    const { id } = match.params
    await fetchVehicles(history, id)
  }

  handleSortIdentifier = vehicle => {
    const newVehicle = vehicle.map(item => {
      item.order = this.getWarnTags(item.codIdentificador) ? -1 : 1
      return item
    })
    newVehicle.sort((a, b) => a.order - b.order)
    return newVehicle
  }

  getWarnTags = identifierId => {
    const listTagsWarn = JSON.parse(sessionStorage.getItem('warnTags'))
    return listTagsWarn && listTagsWarn.tags && listTagsWarn.tags.includes(parseInt(identifierId))
  }

  handleGetVehicle = async identifierNumber => {
    if (identifierNumber.length >= 3) {
      this.setState({ identifiersList: [], isLoadingMoreItems: true })
      const { identificadores, paginacao } = await this.props.fetchVehicles(
        this.props.match.params.id,
        identifierNumber,
        identifierNumber
      )

      this.setState(
        {
          identifiersList: identificadores,
          paginacao
        },
        () => this.setState({ isLoadingMoreItems: false })
      )
    }
  }

  render() {
    const {
      searchText,
      itemsSelected,
      identifiersList,
      isLoadingMoreItems,
      modalOpen,
      vehicle
    } = this.state

    const { account = {} } = this.props
    // const { wl: isWhiteLabel = false } = account
    const { wl, pc } = account

    const isWhiteLabel = wl || pc || false
    return (
      <section>
        <Helmet title={helmetTitle} />
        {!isWhiteLabel && (!identifiersList || identifiersList.length === 0) ? (
          <Content>
            <Heading>{noIdentifierTitle}</Heading>
            <Paragraph>{noIdentifierDescription}</Paragraph>
          </Content>
        ) : (
          <Content>
            <Heading>{isWhiteLabel ? 'Consultar VeloeTag' : identifiersTitle}</Heading>
            <Paragraph>
              {isWhiteLabel
                ? 'Pesquise por número de VeloeTag ou Placa para ver detalhes do dispositivo'
                : identifiersDescription}
            </Paragraph>
            <SearchBox>
              {isWhiteLabel ? (
                <SearchForm
                  value={searchText}
                  onChange={this.handleSearchChange}
                  onSearch={() => this.handleGetVehicle(searchText)}
                  placeholder="Pesquise por número da VeloeTag ou Placa"
                />
              ) : (
                <SearchForm
                  value={searchText}
                  onChange={this.handleSearchChange}
                  placeholder="Busque pela placa, VeloeTag ou Informação gerencial"
                />
              )}
            </SearchBox>
            {!isWhiteLabel ? (
              <IdentifiersList
                handleCreateInf={this.handleModalCreateInfo}
                checkboxValues={itemsSelected}
                handleLoadMoreItems={() => {}}
                handleSelectItem={this.handleSelectItem}
                handleSelectAll={this.handleSelectAll}
                identifiers={identifiersList}
              />
            ) : (
              <IdentifiersList
                handleCreateInf={this.handleModalCreateInfo}
                checkboxValues={itemsSelected}
                handleLoadMoreItems={this.loadMoreItems}
                handleSelectItem={this.handleSelectItem}
                handleSelectAll={this.handleSelectAll}
                identifiers={identifiersList}
                isPartner={isWhiteLabel}
                idConta={this.props.match.params.id}
              />
            )}
            {isLoadingMoreItems && (
              <LoadingContainer>
                <IconLoading />
                <LoadingText>Carregando</LoadingText>
              </LoadingContainer>
            )}
            {modalOpen && (
              <ManagementModal
                vehicle={vehicle}
                isOpen={modalOpen}
                modalStart={'include'}
                toggleModal={this.handleCloseModal}
              />
            )}
          </Content>
        )}
      </section>
    )
  }
}

const mapStateToProps = ({ reducer }) => ({
  vehicles: reducer.dashboardVehicles,
  accountPlans: reducer.accountPlans,
  account: reducer.account
})

const mapDispatchToProps = dispatch => ({
  fetchVehicles: async (idConta, placa, identificador, gerencial, pagina, quantidade) => {
    const { data: { identificadoresPJV2: { identificadores, paginacao } } } = await gqlQuery(
      gqlIdentificadoresPaginado,
      {
        idConta,
        placa,
        identificador,
        gerencial,
        pagina,
        quantidade
      }
    )
    return { identificadores, paginacao }
  },
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  },
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardIdentifiersPartners)



// WEBPACK FOOTER //
// ./src/app/pages/DashboardIdentifiersPartner/index.js